import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface notePayload {
  game: number | string;
  is_private: boolean;
  text: string;
  position?: string
}

@Injectable({
  providedIn: 'root'
})
export class GmNoteService {

  constructor(
    private http: HttpClient
  ) { }

  serviceurl: string = environment.serviceurl;

  getNotes(user_id: string | number, id: string | number) {
    return this.http.get(this.serviceurl + 'api/map-notes/game/' + user_id + '/' + id + '/');
  }

  createNote(user_id: string | number, notePayload: notePayload) {

    notePayload.position = '22,-22'
    return this.http.post(this.serviceurl + 'api/map-notes/create/' + user_id + '/', notePayload);
  }

  deleteNote(user_id: string | number, note_id: string | number) {
    return this.http.delete(this.serviceurl + 'api/map-notes/' + user_id + '/' + note_id + '/delete/');
  }
}
